<p-dialog
  [(visible)]="displayDialog"
  [modal]="true"
  [closable]="false"
  [dismissableMask]="false"
  [resizable]="false"
  styleClass="w-30rem"
  [breakpoints]="{ '960px': '75vw', '640px': '90vw' }">
  <ng-template pTemplate="header">
    <app-header
      styleClass="m-0 text-xl"
      icon="fas fa-cookie"
      text="Hinweis zu Cookies"></app-header>
  </ng-template>

  <p>
    Diese Website verwendet ausschließlich
    <strong>technisch notwendige</strong> Cookies, damit diese Website korrekt
    funktioniert. Es werden keine personenbezogenen Daten gespeichert.
  </p>

  <div class="flex justify-content-end">
    <p-button
      [rounded]="true"
      type="button"
      label="verstanden"
      icon="fas fa-check-circle"
      (click)="giveConsent()"></p-button>
  </div>
</p-dialog>
